import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import {
  Item,
  Label,
  WisestepLogo,
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
} from 'wisestep-base';

import { AuthLayout, WsLink } from '../../../components';

const ResetPassword = () => {
  const location: any = useLocation();
  let email = null;
  if (location?.state?.email) {
    email = location?.state?.email;
  }

  return (
    <AuthLayout>
      <Item sx={{ padding: 13 }}>
        <Stack alignItems="center">
          <WisestepLogo />
        </Stack>
        <Stack mt={10} alignItems="center">
          <Label sx={{ fontSize: '28px', fontWeight: 'bold' }}>Reset Your Password</Label>
        </Stack>
        <Stack mt={3} sx={{ backgroundColor: WsColors.TheBlues200 }} p={3}>
          <WsTypography variant={WsTypoVariants.BODY1}>
            {email
              ? `We sent you a password assistance e-mail to ${email}`
              : `We sent you a password assistance to your e-mail`}
          </WsTypography>
        </Stack>
        <Stack mt={3}>
          <WsTypography variant={WsTypoVariants.BODY1}>
            <Label sx={{ fontWeight: 'bold' }}>Important:</Label>
            If you do not receive the email within a few minutes, check your Spam or Junk folders.
            <br />
            If you find our email in the spam folder click on &quot;Add to address book&quot; so
            that all our future emails are received in your inbox.
            <br />
            If you do not receive that email within 5 minutes, click &quot;Retrieve Password&quot;
            button to receive the details again.
            <br />
            If you have entered the email address incoprrectly. Click here to sign up again.
          </WsTypography>
        </Stack>
        <Stack justifyContent="center" alignItems="center" direction="row" spacing={1}>
          <WsLink to="/">
            <WsTypography
              variant={WsTypoVariants.BODY1}
              color={WsTypoColors.PRIMARY}
              cursor="pointer"
            >
              Log in
            </WsTypography>
          </WsLink>
          <WsTypography variant={WsTypoVariants.BODY1}>/</WsTypography>
          <WsLink to="/sign-up">
            <WsTypography
              variant={WsTypoVariants.BODY1}
              color={WsTypoColors.PRIMARY}
              cursor="pointer"
            >
              Sign Up
            </WsTypography>
          </WsLink>
        </Stack>
      </Item>
    </AuthLayout>
  );
};
export default ResetPassword;
